import { useMutation } from '@tanstack/react-query';

import { artiaProtectedApi } from '@/lib/api-client';
import { MarketShareParams } from '../types/market-share';

export interface MarketShareExportParams {
  drugId: number;
  marketBasketId: number;
  marketBasketName: string;
  stateCode: string;
  utilizationPeriod: string;
  utilizationTypeId: number;
  // Drug names hidden via the chart legend - the export excludes these and
  // renormalizes the remaining drugs' market share to match the on-screen table.
  excludedDrugNames?: string[];
}

const exportMarketShareData = async (params: MarketShareExportParams): Promise<Blob> => {
  const response = await artiaProtectedApi.post('market-share/export', params, {
    responseType: 'blob',
    headers: {
      'Accept': 'text/csv',
    },
  });

  return response.data;
};

export const useMarketShareExport = () => {
  return useMutation({
    mutationFn: exportMarketShareData,
    onSuccess: (blob, variables) => {
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Generate filename based on parameters
      const filename = `market-share-report-${variables.marketBasketName}-${variables.stateCode}-${variables.utilizationPeriod}.csv`;
      link.download = filename;

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    onError: () => {
      // Export failed - handled by React Query error state
    },
  });
};
